module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2b"
  }, [_c('a', {
    attrs: {
      "id": "pref04"
    }
  }), _c('a', {
    attrs: {
      "id": "page_xvii"
    }
  }, [_vm._v("TERMS AND"), _c('br'), _vm._v("ABBREVIATIONS")])]), _c('a', {
    attrs: {
      "id": "page_xvii"
    }
  }, [_c('p', {
    staticClass: "term"
  }, [_c('strong', [_vm._v("Antarctic Convergence")]), _vm._v(" The region where the colder, denser polar waters flowing north meet and dip below the warmer seas flowing south. A marked surface temperature change occurs.")]), _vm._v(" "), _c('p', {
    staticClass: "term"
  }, [_c('strong', [_vm._v("ATCM")]), _vm._v(" Antarctic Treaty Consultative Meeting.")]), _vm._v(" "), _c('p', {
    staticClass: "term"
  }, [_c('strong', [_vm._v("ATCP")]), _vm._v(" Antarctic Treaty Consultative Parties.")]), _vm._v(" "), _c('p', {
    staticClass: "term"
  }, [_c('strong', [_vm._v("ATS")]), _vm._v(" Antarctic Treaty System.")]), _vm._v(" "), _c('p', {
    staticClass: "term"
  }, [_c('strong', [_vm._v("aurora australis")]), _vm._v(" Colorful, moving displays of light in the Antarctic night sky. Atomic particles from the sun, channeled by the earth’s magnetic field, collide with oxygen and nitrogen molecules in the upper atmosphere, releasing visible energy.")])]), _c('p', {
    staticClass: "term"
  }, [_c('a', {
    attrs: {
      "id": "page_xvii"
    }
  }), _c('a', {
    attrs: {
      "id": "page_xviii"
    }
  }, [_c('strong', [_vm._v("austral")]), _vm._v(" Southern; pertaining to the Southern Hemisphere.")])]), _c('a', {
    attrs: {
      "id": "page_xviii"
    }
  }, [_c('p', {
    staticClass: "term"
  }, [_c('strong', [_vm._v("BAS")]), _vm._v(" British Antarctic Survey, formerly Falkland Islands Dependencies Survey (FIDS).")]), _vm._v(" "), _c('p', {
    staticClass: "term"
  }, [_c('strong', [_vm._v("beset")]), _vm._v(" Situation of a ship surrounded by and stuck in the ice.")]), _vm._v(" "), _c('p', {
    staticClass: "term"
  }, [_c('strong', [_vm._v("Big Eye")]), _vm._v(" Insomnia caused by the twenty-four-hour sunlight of austral summer. Also occurs in the continuous dark of winter.")]), _vm._v(" "), _c('p', {
    staticClass: "term"
  }, [_c('strong', [_vm._v("calving")]), _vm._v(" The breaking off of a piece of ice from an ice shelf or glacier to form an iceberg. Tabular (flat-topped) bergs born of ice shelves are unique to the Antarctic.")]), _vm._v(" "), _c('p', {
    staticClass: "term"
  }, [_c('strong', [_vm._v("CCAMLR")]), _vm._v(" Convention on the Conservation of Antarctic Marine Living Resources.")]), _vm._v(" "), _c('p', {
    staticClass: "term"
  }, [_c('strong', [_vm._v("Clements hut")]), _vm._v(" A box-shaped modular building constructed by connecting identical insulated 4′ × 8′ plywood panels. Used for IGY housing.")]), _vm._v(" "), _c('p', {
    staticClass: "term"
  }, [_c('strong', [_vm._v("CO")]), _vm._v(" Commanding officer.")]), _vm._v(" "), _c('p', {
    staticClass: "term"
  }, [_c('strong', [_vm._v("COMNAP")]), _vm._v(" Council of Managers of National Antarctic Programs, an organization of the world’s NSFs.")]), _vm._v(" "), _c('p', {
    staticClass: "term"
  }, [_c('strong', [_vm._v("CPO, CWO")]), _vm._v(" Chief petty officer, chief warrant officer; U.S. Navy enlisted leaders.")]), _vm._v(" "), _c('p', {
    staticClass: "term"
  }, [_c('strong', [_vm._v("CRAMRA")]), _vm._v(" Convention on the Regulation of Antarctic Mineral Resource Activities. Never ratified, it was superseded by the Environmental Protocol.")]), _vm._v(" "), _c('p', {
    staticClass: "term"
  }, [_c('strong', [_vm._v("crevasse")]), _vm._v(" A steep fissure in a glacier that can vary greatly in all dimensions, sometimes dangerously hidden by a wind-formed snow bridge.")]), _vm._v(" "), _c('p', {
    staticClass: "term"
  }, [_c('strong', [_vm._v("CSAGI")]), _vm._v(" Comité Spécial de l’Année Géophysique Internationale, the special committee created by ICSU to plan and implement the IGY.")]), _vm._v(" "), _c('p', {
    staticClass: "term"
  }, [_c('strong', [_vm._v("Deep Freeze, Operation")]), _vm._v(" The code name given U.S. Naval Support Force, Antarctica, Task Force 43.")]), _vm._v(" "), _c('p', {
    staticClass: "term"
  }, [_c('strong', [_vm._v("firn")]), _vm._v(" Old snow that has become dense but retains tiny pockets of air; a transitional substance between snow and ice.")]), _vm._v(" "), _c('p', {
    staticClass: "term"
  }, [_c('strong', [_vm._v("floe")]), _vm._v(" A relatively flat piece of floating sea ice. The U.S. Navy Hydrographic Office, in 1956, suggested that small floes be thought of as about the size of a city block; medium floes, a golf course; giant floes, a small town.")]), _vm._v(" "), _c('p', {
    staticClass: "term"
  }, [_c('strong', [_vm._v("geodesy")]), _vm._v(" The study of the earth’s shape and size and the precise location of points on its surface.")]), _vm._v(" "), _c('p', {
    staticClass: "term"
  }, [_c('strong', [_vm._v("geomagnetic poles")]), _vm._v(" Theoretical points on the earth’s surface visualized as the ends of a bar magnet through its center if all the earth’s magnetic fields were caused by that magnet.")])]), _c('p', {
    staticClass: "term"
  }, [_c('a', {
    attrs: {
      "id": "page_xviii"
    }
  }), _c('a', {
    attrs: {
      "id": "page_xix"
    }
  }, [_c('strong', [_vm._v("geomagnetism")]), _vm._v(" The study of the magnetic phenomena exhibited by the earth; also called terrestrial magnetism.")])]), _c('a', {
    attrs: {
      "id": "page_xix"
    }
  }, [_c('p', {
    staticClass: "term"
  }, [_c('strong', [_vm._v("geophysics")]), _vm._v(" The application of the principles of physics to the study of the earth as a planet.")]), _vm._v(" "), _c('p', {
    staticClass: "term"
  }, [_c('strong', [_vm._v("glacier")]), _vm._v(" A mass of snow and ice continuously moving like a frozen river from higher to lower ground.")]), _vm._v(" "), _c('p', {
    staticClass: "term"
  }, [_c('strong', [_vm._v("glaciology")]), _vm._v(" The study of all forms of glaciers, their characteristics and processes; broadly, the study of all aspects of ice and snow.")]), _vm._v(" "), _c('p', {
    staticClass: "term"
  }, [_c('strong', [_vm._v("Gondwanaland")]), _vm._v(" Vast proto-continent of the Southern Hemisphere.")]), _vm._v(" "), _c('p', {
    staticClass: "term"
  }, [_c('strong', [_vm._v("GPS")]), _vm._v(" Global Positioning System, a satellite-based triangulation method that determines geographic location on earth within a few meters.")]), _vm._v(" "), _c('p', {
    staticClass: "term"
  }, [_c('strong', [_vm._v("Grid")]), _vm._v(" A coordinate system used for navigating near the Pole, where the lines of longitude converge and all directions are north. The Prime Meridian (0°) is arbitrarily designated Grid North, making 180° Grid South, and so on.")]), _vm._v(" "), _c('p', {
    staticClass: "term"
  }, [_c('strong', [_vm._v("ham")]), _vm._v(" An amateur shortwave-radio operator.")]), _vm._v(" "), _c('p', {
    staticClass: "term"
  }, [_c('strong', [_vm._v("hamgram")]), _vm._v(" A message transmitted from Antarctica in Morse code, translated and typed out by the receiving U.S. ham and mailed to the addressee. Hamgrams were also sent from the States.")]), _vm._v(" "), _c('p', {
    staticClass: "term"
  }, [_c('strong', [_vm._v("heavy swing, or swing")]), _vm._v(" Another name for the tractor trains that supplied inland Byrd Station from Little America.")]), _vm._v(" "), _c('p', {
    staticClass: "term"
  }, [_c('strong', [_vm._v("Hercules")]), _vm._v(" A C-130, a four-engine transport plane denoted LC-130 when ski-equipped; popularly called a “Herc.”")]), _vm._v(" "), _c('p', {
    staticClass: "term"
  }, [_vm._v("i"), _c('strong', [_vm._v("ceberg")]), _vm._v(" A large mass of floating or stranded freshwater ice broken away from a glacier or ice shelf—by definition, about the size of a ship or larger. Smaller bergy bits are about the size of a small cottage; hazardous, difficult-to-see growlers, a grand piano; brash ice, loose fragments of wrecked ice forms, small pool-table size.")]), _vm._v(" "), _c('p', {
    staticClass: "term"
  }, [_c('strong', [_vm._v("ice sheet")]), _vm._v(" A mass of snow and glacier ice of considerable breadth and thickness overlying a large land area (rock) or floating. An ice cap is similar but smaller in extent.")]), _vm._v(" "), _c('p', {
    staticClass: "term"
  }, [_c('strong', [_vm._v("ice shelf")]), _vm._v(" The floating extension of a continental ice sheet beyond the coastline. Its seaward edge is called an ice front.")]), _vm._v(" "), _c('p', {
    staticClass: "term"
  }, [_c('strong', [_vm._v("ICSU")]), _vm._v(" International Council of Scientific Unions, parent organization for the IGY.")]), _vm._v(" "), _c('p', {
    staticClass: "term"
  }, [_c('strong', [_vm._v("IGY")]), _vm._v(" International Geophysical Year, 1 July 1957 through 31 December 1958.")])]), _c('p', {
    staticClass: "term"
  }, [_c('a', {
    attrs: {
      "id": "page_xix"
    }
  }), _c('a', {
    attrs: {
      "id": "page_xx"
    }
  }, [_c('strong', [_vm._v("Jamesway")]), _vm._v(" An easily assembled prefabricated hut made of wooden arches covered with insulated canvas. Of Korean War vintage, used by the military in cold climates.")])]), _c('a', {
    attrs: {
      "id": "page_xx"
    }
  }, [_c('p', {
    staticClass: "term"
  }, [_c('strong', [_vm._v("JATO")]), _vm._v(" Jet-assisted takeoff, achieved by exploding gases in canisters strapped to aircraft.")]), _vm._v(" "), _c('p', {
    staticClass: "term"
  }, [_c('strong', [_vm._v("katabatic")]), _vm._v(" Fierce, gravity-driven winds caused by cold, dense air rushing down from the polar plateau toward the coast.")]), _vm._v(" "), _c('p', {
    staticClass: "term"
  }, [_c('strong', [_vm._v("knot")]), _vm._v(" A nautical unit of speed. One nautical or geographical mile equals 1.15 statute miles (1.85 km).")]), _vm._v(" "), _c('p', {
    staticClass: "term"
  }, [_c('strong', [_vm._v("lead")]), _vm._v(" A ribbon or path of open water within floes of pack ice that enable a ship to move through.")]), _vm._v(" "), _c('p', {
    staticClass: "term"
  }, [_c('strong', [_vm._v("LGP")]), _vm._v(" Low ground pressure, obtained by widening the tracks of a tractor to distribute its weight over the snow.")]), _vm._v(" "), _c('p', {
    staticClass: "term"
  }, [_c('strong', [_vm._v("magnetic poles")]), _vm._v(" The migrating points on the earth’s surface to which the poles of a compass needle point, where the earth’s magnetic lines of force are vertical.")]), _vm._v(" "), _c('p', {
    staticClass: "term"
  }, [_c('strong', [_vm._v("NAS")]), _vm._v(" National Academy of Sciences, a private organization to which distinguished scientists are elected. By federal charter (1863) it advises the government on scientific and technological matters.")]), _vm._v(" "), _c('p', {
    staticClass: "term"
  }, [_c('strong', [_vm._v("NBS")]), _vm._v(" National Bureau of Standards, a federal agency devoted to establishing accurate measurement standards for U.S. science, industry, and commerce.")]), _vm._v(" "), _c('p', {
    staticClass: "term"
  }, [_c('strong', [_vm._v("névé")]), _vm._v(" Literally, “last year’s snow.” Hard, granular, consolidated snow on the upper part of a glacier that has not yet turned to solid glacial ice.")]), _vm._v(" "), _c('p', {
    staticClass: "term"
  }, [_c('strong', [_vm._v("NRC")]), _vm._v(" National Research Council, the research arm of the National Academy of Sciences.")]), _vm._v(" "), _c('p', {
    staticClass: "term"
  }, [_c('strong', [_vm._v("NSB")]), _vm._v(" National Science Board, the NSF board of directors.")]), _vm._v(" "), _c('p', {
    staticClass: "term"
  }, [_c('strong', [_vm._v("NSC")]), _vm._v(" National Security Council, an interdepartmental, interagency group advising the president on military and foreign policy issues.")]), _vm._v(" "), _c('p', {
    staticClass: "term"
  }, [_c('strong', [_vm._v("NSF")]), _vm._v(" National Science Foundation, an independent federal agency promoting the progress of science by support of research through grants and contracts.")]), _vm._v(" "), _c('p', {
    staticClass: "term"
  }, [_c('strong', [_vm._v("NSFA")]), _vm._v(" Naval Support Force, Antarctica. Designated Task Force 43.")]), _vm._v(" "), _c('p', {
    staticClass: "term"
  }, [_c('strong', [_vm._v("nunatak")]), _vm._v(" “Lonely rock” in Inuit; the top of a mountain or large rock projecting up through an ice sheet.")]), _vm._v(" "), _c('p', {
    staticClass: "term"
  }, [_c('strong', [_vm._v("OAE")]), _vm._v(" Old Antarctic explorer.")])]), _c('p', {
    staticClass: "term"
  }, [_c('a', {
    attrs: {
      "id": "page_xx"
    }
  }), _c('a', {
    attrs: {
      "id": "page_xxi"
    }
  }, [_c('strong', [_vm._v("OCB")]), _vm._v(" Operations Coordinating Board, an interagency body of the National Security Council charged to uphold national interests during the IGY. Admiral Dufek chaired its working group on Antarctica.")])]), _c('a', {
    attrs: {
      "id": "page_xxi"
    }
  }, [_c('p', {
    staticClass: "term"
  }, [_c('strong', [_vm._v("pack ice")]), _vm._v(" An area of drifting sea ice, whether loose floes or consolidated (frozen together), covering the sea surface with little or no open water.")]), _vm._v(" "), _c('p', {
    staticClass: "term"
  }, [_c('strong', [_vm._v("phone patch")]), _vm._v(" A way of talking with someone at home. The Antarctic station radio operator contacted a U.S. “ham,” who would telephone the desired person. The callee would pay any U.S. phone charges.")]), _vm._v(" "), _c('p', {
    staticClass: "term"
  }, [_c('strong', [_vm._v("polynya")]), _vm._v(" A “lake” (area of open water) within the pack ice.")]), _vm._v(" "), _c('p', {
    staticClass: "term"
  }, [_c('strong', [_vm._v("PRB")]), _vm._v(" Polar Research Board of the National Academy of Sciences, an advisory body on scientific programs. From its origins in 1958 until 1975, it was called the Committee on Polar Research.")]), _vm._v(" "), _c('p', {
    staticClass: "term"
  }, [_c('strong', [_vm._v("pressure ice")]), _vm._v(" Floating ice that has been squeezed together by wind or currents, often forced upward into rafted (overriding) ice, hummocks (mounds), or ridges.")]), _vm._v(" "), _c('p', {
    staticClass: "term"
  }, [_c('strong', [_vm._v("SAR")]), _vm._v(" Search and rescue.")]), _vm._v(" "), _c('p', {
    staticClass: "term"
  }, [_c('strong', [_vm._v("sastrugi")]), _vm._v(" Wind- and erosion-formed “dunes” of snow. The irregular ridges, parallel to the direction of the prevailing wind, can be high, sharp, and very hard.")]), _vm._v(" "), _c('p', {
    staticClass: "term"
  }, [_c('strong', [_vm._v("SCAR")]), _vm._v(" Scientific (until 1961, Special) Committee on Antarctic Research, an international group charged to recommend scientific programs to participating governments within the ATS.")]), _vm._v(" "), _c('p', {
    staticClass: "term"
  }, [_c('strong', [_vm._v("Seabees")]), _vm._v(" Members of the construction battalions of the U.S. Navy’s Civil Engineer Corps, founded in World War II.")]), _vm._v(" "), _c('p', {
    staticClass: "term"
  }, [_c('strong', [_vm._v("seismology")]), _vm._v(" The study of earthquakes and the vibrations (seismic waves) they produce in the earth. During the IGY, seismic waves were produced by explosives to study ice depth and materials beneath it.")]), _vm._v(" "), _c('p', {
    staticClass: "term"
  }, [_c('strong', [_vm._v("serac")]), _vm._v(" A pointed ice ridge in a crevassed area.")]), _vm._v(" "), _c('p', {
    staticClass: "term"
  }, [_c('strong', [_vm._v("SIPRE")]), _vm._v(" Snow, Ice and Permafrost Research Establishment of the U.S. Army Corps of Engineers.")]), _vm._v(" "), _c('p', {
    staticClass: "term"
  }, [_c('strong', [_vm._v("SITREP")]), _vm._v(" Situation report.")]), _vm._v(" "), _c('p', {
    staticClass: "term"
  }, [_c('strong', [_vm._v("synoptic")]), _vm._v(" Occurring simultaneously in numerous locations.")]), _vm._v(" "), _c('p', {
    staticClass: "term"
  }, [_c('strong', [_vm._v("TAE")]), _vm._v(" The British Commonwealth Transantarctic Expedition.")]), _vm._v(" "), _c('p', {
    staticClass: "term"
  }, [_c('strong', [_vm._v("the ice")]), _vm._v(" Antarctica.")])]), _c('p', {
    staticClass: "term"
  }, [_c('a', {
    attrs: {
      "id": "page_xxi"
    }
  }, [_c('strong', [_vm._v("USAP")]), _vm._v(" United States Antarctic Program, the successor to USARP in 1971 ")]), _c('a', {
    attrs: {
      "id": "page_xxii"
    }
  }, [_vm._v("when NSF assumed responsibility for all U.S. Antarctic activities, including support operations purchased from the Navy.")])]), _c('a', {
    attrs: {
      "id": "page_xxii"
    }
  }, [_c('p', {
    staticClass: "term"
  }, [_c('strong', [_vm._v("USARP")]), _vm._v(" United States Antarctic Research Program, established by NSF in March 1959 to coordinate the overall U.S. Antarctic program and manage its budget.")]), _vm._v(" "), _c('p', {
    staticClass: "term"
  }, [_c('strong', [_vm._v("USCG")]), _vm._v(" United States Coast Guard.")]), _vm._v(" "), _c('p', {
    staticClass: "term"
  }, [_c('strong', [_vm._v("USGS")]), _vm._v(" United States Geological Survey.")]), _vm._v(" "), _c('p', {
    staticClass: "term"
  }, [_c('strong', [_vm._v("USN")]), _vm._v(" United States Navy.")]), _vm._v(" "), _c('p', {
    staticClass: "term"
  }, [_c('strong', [_vm._v("USNC")]), _vm._v(" or "), _c('strong', [_vm._v("USNC-IGY")]), _vm._v(" United States National Committee for the IGY.")]), _vm._v(" "), _c('p', {
    staticClass: "term"
  }, [_c('strong', [_vm._v("VX-6")]), _vm._v(" Air Development Squadron SIX, the Navy’s air arm for Operation Deep Freeze.")]), _vm._v(" "), _c('p', {
    staticClass: "term"
  }, [_c('strong', [_vm._v("VXE-6")]), _vm._v(" Antarctic Development Squadron SIX, successor to VX-6, established in 1969.")]), _vm._v(" "), _c('p', {
    staticClass: "term"
  }, [_c('strong', [_vm._v("wanigan")]), _vm._v(" A small hut mounted on a tractor-pulled sled for use by a field party.")]), _vm._v(" "), _c('p', {
    staticClass: "term"
  }, [_c('strong', [_vm._v("whiteout")]), _vm._v(" A disorienting condition in which light is diffused by multiple reflections between a low overcast sky and the snow surface so that shadows vanish, making it impossible to distinguish the horizon or surface features.")]), _vm._v(" "), _c('p', {
    staticClass: "term"
  }, [_c('strong', [_vm._v("WMO")]), _vm._v(" World Meteorological Organization.")]), _vm._v(" "), _c('p', {
    staticClass: "term"
  }, [_c('strong', [_vm._v("Zulu")]), _vm._v(" Phonetic for “z,” the zero meridian of longitude, which runs through Greenwich, England. Zulu Time, or Greenwich Mean Time (GMT), was used for recording scientific observations.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-02d5f94e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pref04.vue
// module id = 84
// module chunks = 0